import {formatDate, formatDuration} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/timeClock/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/timeClock/COMMON_REQ_FAIL';

export const LOAD_TIME_CLOCKS_SEARCH_SUCCESS = 'cris/timeClock/LOAD_TIME_CLOCKS_SEARCH_SUCCESS';
export const LOAD_TIME_CLOCKS_SUCCESS = 'cris/timeClock/LOAD_TIME_CLOCKS_SUCCESS';
export const LOAD_APPROVE_TIME_CLOCKS_SUCCESS = 'cris/timeClock/LOAD_APPROVE_TIME_CLOCKS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	businessUnits: [],
	businessUnitLocations: [],
	timeClocks: [],
	approveTimeClocks: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_TIME_CLOCKS_SEARCH_SUCCESS:
			const businessUnits = action.payload.data.business_units.map((item) => ({
				id: item.id,
				name: item.name,
				code: item.code
			}));

			const businessUnitLocations = action.payload.data.business_unit_locations.map((item) => ({
				id: item.id,
				name: item.name,
				business_unit_id: item.business_unit_id
			}));

			return {
				...state,
				isLoading: false,
				businessUnits: businessUnits,
				businessUnitLocations: businessUnitLocations
			};

		case LOAD_TIME_CLOCKS_SUCCESS:
			const timeClocks = action.payload.data.time_clocks.map((item) => ({
				id: item.id,
				business_unit_name: item.business_unit.name,
				business_unit_location_name: item.business_unit_location.name,
				user_name: item.user.name,
				clock_in_time: item.clock_in_time,
				formattedClockInTime: formatDate(item.clock_in_time, 'MMM DD, YYYY HH:mm:ss'),
				clock_in_picture: item.clock_in_picture,
				clock_in_picture_url: item.clock_in_picture_url,
				clock_out_time: item.clock_out_time || '',
				formattedClockOutTime: item.clock_out_time ? formatDate(item.clock_out_time, 'MMM DD, YYYY HH:mm:ss') : '',
				clock_out_picture: item.clock_out_picture || '',
				clock_out_picture_url: item.clock_out_picture_url || '',
				approved_status: item.approved_status,
				formattedClockHours: item.clock_out_time ? formatDuration(item.clock_in_time, item.clock_out_time) : ''
			}));

			return {
				...state,
				isLoading: false,
				timeClocks: timeClocks
			};

		case LOAD_APPROVE_TIME_CLOCKS_SUCCESS:
			const approveTimeClocks = action.payload.data.time_clocks.map((item) => ({
				id: item.id,
				business_unit_name: item.business_unit.name,
				business_unit_location_name: item.business_unit_location.name,
				user_name: item.user.name,
				clock_in_time: item.clock_in_time,
				formattedClockInTime: formatDate(item.clock_in_time, 'MMM DD, YYYY HH:mm:ss'),
				clock_in_picture: item.clock_in_picture,
				clock_in_picture_url: item.clock_in_picture_url,
				clock_out_time: item.clock_out_time || '',
				formattedClockOutTime: item.clock_out_time ? formatDate(item.clock_out_time, 'MMM DD, YYYY HH:mm:ss') : '',
				clock_out_picture: item.clock_out_picture || '',
				clock_out_picture_url: item.clock_out_picture_url || '',
				approved_status: item.approved_status,
				formattedClockHours: item.clock_out_time ? formatDuration(item.clock_in_time, item.clock_out_time) : ''
			}));

			return {
				...state,
				isLoading: false,
				approveTimeClocks: approveTimeClocks
			};

		default:
			return state;
	}
}